import { z } from 'zod';
import { idArray } from './shared.schema';

const filterSchema = z.discriminatedUnion('type', [
	z.object({
		type: z.literal('accountId'),
		value: z.number().int(),
	}),
	z.object({
		type: z.literal('subscriptionName'),
		value: z.string().trim().min(1),
	}),
	z.object({
		type: z.literal('invoiceId'),
		value: z.string().trim().min(1),
	}),
	z.object({
		type: z.literal('creditId'),
		value: z.string().trim().min(1),
	}),
]);

const timePattern = /^\d{2}:\d{2}$/;

export const transactionTimeRangeTimezoneSchema = z.union([z.literal('facility'), z.string().trim().min(1)]);

export const transactionTimeRangeSchema = z
	.object({
		timezone: transactionTimeRangeTimezoneSchema,
		startTime: z.string().regex(timePattern).optional(),
		endTime: z.string().regex(timePattern).optional(),
	})
	.refine(({ startTime, endTime }) => startTime || endTime, {
		message: 'A start time or end time is required.',
	});

export const transactionParametersSchema = z
	.strictObject({
		startDate: z.iso.date(),
		endDate: z.iso.date().optional(),
		displayTimezone: transactionTimeRangeTimezoneSchema.optional(),
		timeRange: transactionTimeRangeSchema.optional(),
		filter: filterSchema.optional(),
		areaIds: idArray.optional(),
		branchIds: idArray.optional(),
		districtIds: idArray.optional(),
		facilityIds: z.array(z.string()).optional(),
	})
	.superRefine((value, ctx) => {
		if (value.endDate && value.endDate < value.startDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['endDate'],
				message: 'endDate must not be before startDate',
			});
		}
	});

export type TransactionParameters = z.infer<typeof transactionParametersSchema>;
